import {KpiPerformanceDto} from '@hconnect/common/types'

import type {KpiData, KpiValueTypeDto} from '../types'
import {getKpiTypeKey} from '../utils'

export const mapKpiPerformanceToPlantStatusKpis = (
  kpiPerformance: KpiPerformanceDto | undefined
): KpiData[] => {
  return (
    kpiPerformance?.kpiAssignments.map((kpi) => ({
      key: kpi.kpiName,
      name: kpi.kpiName,
      value: kpi.result?.value,
      unit: kpi.result?.unit,
      kpiBreachSeverity: kpi.result?.kpiBreachSeverity
    })) ?? []
  )
}

export const mapKpiValueTypeToKpiData = (kpis: KpiValueTypeDto[] | undefined): KpiData[] => {
  return (
    kpis?.map((kpi) => ({
      key: getKpiTypeKey(kpi.kpiType, kpi.kpiName, kpi.equipmentName),
      label: kpi?.kpiType,
      name: kpi?.kpiName,
      value: kpi?.value?.toString(),
      equipmentName: kpi?.equipmentName,
      unit: kpi?.unit,
      kpiBreachSeverity: kpi?.kpiBreachSeverity,
      kpiSource: kpi?.kpiSource
    })) ?? []
  )
}
